import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { type FunctionComponent } from 'react';

type PhoneProps = {
    className?: string;
};

const Phone: FunctionComponent<PhoneProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'phone'}
            viewBox="0 0 250 250"
        >
            <path d="M199.1 248.7h-.2c-24.3-.7-51.7-13.1-81.5-36.6-20.9-16.5-35.2-32.6-37.1-34.7-44.7-40.4-70.9-89.9-72-92l-.1-.3c-14.1-31.8 3-52.4 3.8-53.2l.2-.2 19.6-19.8c4.2-3.6 9.6-8 11.8-8.9 3.1-1.4 6.3-2 9.4-2 9.8 0 16.5 6.2 16.7 6.4l.1.1 29.9 29.9c6.9 6.4 10.3 13.2 10.2 20.3-.2 10-7.6 16.4-8 16.7l-13.7 12c-7.9 5.6-2.6 16.9-1.8 18.5 23.3 35.2 60.1 58.1 60.5 58.4 4 2.5 7.8 3.8 11.5 3.8 3.8 0 6.2-1.4 6.7-1.8l16.6-15.6c4.5-3.4 9.2-5.1 14.2-5.1 10.1 0 17.4 7.3 18.6 8.6l26.9 25.2c10.6 7.9 12.9 20.4 6.2 34.3-1.1 2.4-4.3 6.3-5.3 7.5l-.1.1-13.6 15.3c-12.3 12.7-27.8 13.1-29.5 13.1zM16.3 81.4c1.5 2.8 27.6 51.1 70.2 89.4l.4.4c.1.2 14.9 17.1 36.2 33.9 19.4 15.3 48.3 33.8 76 34.6.5 0 13.2-.1 23.1-10.3l13.3-15c1.6-2 3.6-4.7 4.1-5.6 3.3-7 5.4-16.7-3.6-23.3l-.4-.4-27.5-25.8s-5.3-5.8-12-5.8c-2.9 0-5.8 1.1-8.6 3.2l-16.7 15.6c-.5.4-5 3.7-12.3 3.7-5.4 0-10.8-1.7-16.2-5.2-1.5-.9-39-24.3-63.3-61.2l-.2-.4c-3.6-6.8-7.3-21.7 4.3-30.1l13.3-11.6c.1-.1 4.7-4.2 4.8-10.1.1-4.4-2.4-8.9-7.3-13.5l-.1-.1-30.2-29.9C63.2 13.6 59 10 53 10c-2 0-4 .4-5.9 1.2-1.2.6-5.7 4.3-9.3 7.3L18.7 37.8c-1.2 1.6-13.6 18-2.4 43.6z" />
        </svg>
    );
};
export default Phone;
